import { Job, JobEndpoint } from "../domain/job.model";

function formatearFecha(fechaISO?: string | null): string {
    if (!fechaISO) return "";

    const date = new Date(fechaISO.replace(/Z$/, ""));
    if (isNaN(date.getTime())) return "";

    const pad2 = (num: number) => num.toString().padStart(2, "0");

    const dia = pad2(date.getDate());
    const mes = pad2(date.getMonth() + 1);
    const anio = date.getFullYear();

    const hora = pad2(date.getHours());
    const minutos = pad2(date.getMinutes());
    const segundos = pad2(date.getSeconds());

    return `${dia}-${mes}-${anio} ${hora}:${minutos}:${segundos}`;
}

export const createAdapterFromEndpointToJob = (jobEndpoint: JobEndpoint): Job => {
    const { 
        JobID,
        Job,
        FechaCreacion,
        Estado,
        Resultado,
        UltimaEjecucion,
        FechaEjecucion,
        UsuarioEjecucion,
        EjecucionID,
        EstadoEjecucion,
        Mensaje
    } = jobEndpoint;

    const job: Job = {
        id: JobID ?? '',
        job: Job ?? '',
        createdAt: formatearFecha(FechaCreacion),
        status: Estado ?? '',
        result: Resultado ?? '',
        ejecutionDate: formatearFecha(FechaEjecucion),
        ejecutionUsername: UsuarioEjecucion ?? '',
        lastEjecutionDate: formatearFecha(UltimaEjecucion) ?? '',
        lastEjecutionUsername: UsuarioEjecucion ?? '',
        enabled: Estado === 'Habilitado' ? true : false,
        executionId: EjecucionID ?? -1,
        executionStatus: EstadoEjecucion ?? '',
        message: Mensaje ?? ''
    };
    return job;
}

export const createAdapterFromJobToEndpoint = (job: Job): JobEndpoint => {
    const { id, job: jobName, createdAt, status, result, lastEjecutionDate} = job;
    const jobEndpoint: JobEndpoint = {
        JobID: id ?? '',
        Job: jobName ?? '',
        FechaCreacion: createdAt ?? '',
        Estado: status ?? '',
        Resultado: result ?? '',
        UltimaEjecucion: lastEjecutionDate ?? ''
    };
    return jobEndpoint;
}